// extracted by mini-css-extract-plugin
export default {"modal_content":"rejectModal_modal_content__lvm1q","top":"rejectModal_top__BBo74"};